import { useMemo, useState } from 'react';
import { useStudioStoryContextLoader } from '@hooks/studioContext';
import StudioContext from '@contexts/StudioContext';

export const StudioContextProvider = ({ children }) => {
  const studioStoryValue = useStudioStoryContextLoader();
  const [templateAssetTypes, setTemplateAssetTypes] = useState([]);
  const studioContextValue = useMemo(
    () => ({
      ...studioStoryValue,
      templateAssetTypes,
      setTemplateAssetTypes,
    }),
    [studioStoryValue, templateAssetTypes]
  );

  return (
    <StudioContext.Provider value={studioContextValue}>
      {children}
    </StudioContext.Provider>
  );
};
